/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext, useContext } from 'react';
import { DossierFormulaire } from '../hooks/useDossierFormulaire';

const currentPrestationId: number = 0;
const dataLoaded: boolean = false;
const hasNonPersistedChanges: boolean = false;
const processing: boolean = false;
const formulaires: Array<DossierFormulaire> = [];
const setCurrentPrestationId: React.Dispatch<React.SetStateAction<number>> = () => {};
const getCurrentFormulaire = (): DossierFormulaire | undefined => undefined;
const persistAllFormulaires = async (): Promise<void> => {};
const updateFormulaire = (formulaire: DossierFormulaire): void => {};
const setDataLoaded: React.Dispatch<React.SetStateAction<boolean>> = () => {};

const DossierFormulaireContext = createContext({
    currentPrestationId,
    formulaires,
    dataLoaded,
    hasNonPersistedChanges,
    processing,
    setCurrentPrestationId,
    getCurrentFormulaire,
    persistAllFormulaires,
    updateFormulaire,
    setDataLoaded,
});

export const useDossierFormulaireContext = () => useContext(DossierFormulaireContext);

export default DossierFormulaireContext;
